// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3VgQy","disabled":"FileBtn_disabled__3JNmd","warn":"FileBtn_warn__38q2_","fade":"FileBtn_fade__3mqD1"};